<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="8"
          >
            <div>
              <div>
                <div class="text-primary font-weight-bold font-medium-2">
                  {{ formData.title }}
                </div>
              </div>
              <div>
                {{ formData.customer_company }}
              </div>
              <div>
                {{ formData.name }}
              </div>
              <div>
                {{ formData.customer_phone }}
              </div>
              <div>
                {{ formData.customer_email }}
              </div>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <div>
              <div class="font-weight-bolder font-medium-4 mb-1 d-flex justify-content-between">
                <span>Teklif No:</span>
                <span class="invoice-number">
                  {{ formData.onum }}
                  <span
                    v-if="formData.onum_rno"
                    class="text-danger"
                  >
                    R{{ formData.onum_rno }}
                  </span>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="font-weight-bold">
                  Teklif Tarihi:
                </span>
                <span>
                  {{ moment(formData.odate).format('DD.MM.YYYY') }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="font-weight-bold">
                  Durum:
                </span>
                <span>
                  {{ formData.offer_status }}
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="font-weight-bold">
                  Hazırlayan:
                </span>
                <span>
                  {{ formData.username }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col
            md="4"
            class="text-center"
          >
            <div class="border-1 border-light width-200 height-50 rounded mx-auto">
              <div class="font-weight-bold">
                <FeatherIcon icon="CalendarIcon" /> Teslim Süresi
              </div>
              <div class="text-primary">
                {{ formData.delivery_time? formData.delivery_time : '-' }}
              </div>
            </div>
          </b-col>
          <b-col
            md="4"
            class="text-center"
          >
            <div class="border-1 border-light width-200 height-50 rounded mx-auto">
              <div class="font-weight-bold">
                <FeatherIcon icon="MapPinIcon" /> Teslim Yeri
              </div>
              <div class="text-primary">
                {{ formData.delivery_location }}
              </div>
            </div>
          </b-col>
          <b-col
            md="4"
            class="text-center"
          >
            <div class="border-1 border-light width-200 height-50 rounded mx-auto">
              <div class="font-weight-bold">
                <FeatherIcon icon="DollarSignIcon" /> Ödeme
              </div>
              <div class="text-primary">
                {{ formData.payment }}
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-table
        v-if="linesData.length > 0"
        hover
        :fields="fields"
        :items="linesData"
      >
        <template #cell(text)="data">
          {{ data.item.text }}
        </template>
        <template #cell(quantity)="data">
          <div class="text-center">
            {{ data.item.quantity }} {{ data.item.unit }}
          </div>
        </template>
        <template #cell(product_price)="data">
          <div class="text-center">
            {{ priceFormater(data.item.product_price) }} {{ data.item.currency_symbol }}
          </div>
        </template>
        <template #cell(labor_price)="data">
          <div class="text-center">
            {{ priceFormater(data.item.labor_price) }} {{ data.item.currency_symbol }}
          </div>
        </template>
        <template #cell(unit_price)="data">
          <div class="text-center">
            {{ priceFormater(data.item.unit_price) }} {{ data.item.currency_symbol }}
          </div>
        </template>
        <template #cell(discount_rate)="data">
          <div class="text-center">
            <span v-if="data.item.discount_rate > 0">
              % {{ data.item.discount_rate }}
            </span>
            <span v-else>-</span>
          </div>
        </template>
        <template #cell(discount_price)="data">
          <div class="text-center">
            <span v-if="data.item.discount_price > 0">
              {{ priceFormater(data.item.discount_price) }} {{ data.item.currency_symbol }}
            </span>
            <span v-else>-</span>
          </div>
        </template>
        <template #cell(total)="data">
          <div class="text-right">
            {{ calcRowTotal(data.item) }} {{ data.item.currency_symbol }}
          </div>
        </template>
      </b-table>
      <b-card-footer v-if="linesData.length > 0">
        <b-row>
          <b-col class="font-weight-bolder font-medium-2">
            Teklif Toplamı
          </b-col>
          <b-col class="text-right text-primary font-weight-bolder font-medium-2">
            {{ publicTotal }} {{ linesData[0].currency_symbol }}
          </b-col>
        </b-row>
      </b-card-footer>
      <b-card-body class="bg-light">
        <div class="font-weight-bolder font-medium-2">
          Özel Şartlar
        </div>
        <div v-html="formData.terms" />
      </b-card-body>
    </b-card>
    <b-button
      variant="primary"
      :to="'/offers/edit/' + formData.id"
      :disabled="formData.id_offer_status === '3'"
    ><FeatherIcon icon="EditIcon" />
      Teklifi Güncelle
    </b-button>
    <b-button
      v-b-modal.modal-print
      class="ml-1"
      variant="danger"
    >
      <FeatherIcon icon="PrinterIcon" />
      Yazdır
    </b-button>
    <div
      v-if="formData.id_offer_status !== '1'"
      class="float-right"
    >
      <b-button
        v-if="!revisedLoading"
        variant="warning"
        :disabled="formData.id_offer_status === '3'"
        @click="createRevised"
      >
        <FeatherIcon icon="EditIcon" />
        Revize Oluştur
      </b-button>
      <b-button
        v-else
        variant="warning"
        disabled
      >
        <b-spinner small />
        Lütfen bekleyiniz...
      </b-button>
    </div>
    <b-modal
      id="modal-print"
      title="Teklif Yazdır"
      centered
      hide-footer
    >
      <b-row class="mb-2">
        <b-col
          sm="12"
          md="4"
          class="text-center"
        >
          <b-form-group label="Miktar Göster">
            <b-form-checkbox
              v-model="printParams.quantity"
              checked="true"
              class="custom-control-primary"
              name="check-button"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="4"
          class="text-center"
        >
          <b-form-group label="İşçilik Göster">
            <b-form-checkbox
              v-model="printParams.labor_price"
              checked="true"
              class="custom-control-primary"
              name="check-button"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="4"
          class="text-center"
        >
          <b-form-group label="Malz. Fiyatı Göster">
            <b-form-checkbox
              v-model="printParams.product_price"
              checked="true"
              class="custom-control-primary"
              name="check-button"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="4"
          class="text-center"
        >
          <b-form-group label="İskonto Göster">
            <b-form-checkbox
              v-model="printParams.discount"
              checked="true"
              class="custom-control-primary"
              name="check-button"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="4"
          class="text-center"
        >
          <b-form-group label="Tutar Göster">
            <b-form-checkbox
              v-model="printParams.rowTotal"
              checked="true"
              class="custom-control-primary"
              name="check-button"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="4"
          class="text-center"
        >
          <b-form-group label="Toplam İskonto">
            <b-form-checkbox
              v-model="printParams.discountTotal"
              checked="true"
              class="custom-control-primary"
              name="check-button"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="12"
          class="text-center"
        >
          <b-form-group label="Birim Fiyatı Göster">
            <b-form-checkbox
              v-model="printParams.unit_price"
              checked="true"
              class="custom-control-primary"
              name="check-button"
              switch
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="text-center">
        <b-button
          variant="outline-danger"
          :href="printButton"
          target="_blank"
        >
          <FeatherIcon icon="PrinterIcon" /> PDF'e Aktar
        </b-button>
        <b-button
          variant="outline-success"
          :href="excelButton"
          target="_blank"
          class="ml-1"
        >
          <FeatherIcon icon="FileTextIcon" /> Excel'e Aktar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BCardBody,
  BCardFooter,
  BTable,
  BRow,
  BCol,
  BModal,
  BFormCheckbox,
  BFormGroup,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'OffersView',
  components: {
    BCard,
    BButton,
    BCardBody,
    BCardFooter,
    BTable,
    BRow,
    BCol,
    BModal,
    BFormCheckbox,
    BFormGroup,
    BSpinner,
  },
  data() {
    return {
      formData: {
        onum: null,
        title: null,
        odate: null,
        sdate: null,
        customer_company: null,
        customer_name: null,
        offer_status: null,
        id_customers: null,
        id_offer_status: null,
        id_user: null,
        created: null,
        modified: null,
      },
      linesData: [],
      fields: [
        {
          key: 'text',
          label: 'Ürün Adı',
          thClass: 'text-nowrap align-middle',
        },
        {
          key: 'quantity',
          label: 'MİKTAR',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'product_price',
          label: 'MALZEME',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'labor_price',
          label: 'İŞÇİLİK',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'unit_price',
          label: 'BİRİM FİYAT',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'discount_rate',
          label: 'İSKONTO ORANI',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'discount_price',
          label: 'İSKONTO TUTARI',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'total',
          label: 'TOPLAM',
          thStyle: { width: '160px', textAlign: 'right', verticalAlign: 'middle' },
        },
      ],
      publicTotal: 0,
      printParams: {
        quantity: true,
        labor_price: true,
        product_price: true,
        unit_price: true,
        discount: true,
        discountTotal: true,
        rowTotal: true,
      },
      revisedLoading: false,
    }
  },
  computed: {
    printButton() {
      const urlParams = [
        `&id=${this.$route.params.id}`,
        `quantity=${this.printParams.quantity}`,
        `labor_price=${this.printParams.labor_price}`,
        `product_price=${this.printParams.product_price}`,
        `unit_price=${this.printParams.unit_price}`,
        `discount=${this.printParams.discount}`,
        `discountTotal=${this.printParams.discountTotal}`,
        `rowTotal=${this.printParams.rowTotal}`,
      ].join('&')
      const url = `${this.$store.state.app.baseURL}/export/offers/pdf?token=${localStorage.getItem('refreshToken')}${urlParams}`
      return url
    },
    excelButton() {
      const urlParams = [
        `&id=${this.$route.params.id}`,
        `quantity=${this.printParams.quantity}`,
        `labor_price=${this.printParams.labor_price}`,
        `product_price=${this.printParams.product_price}`,
        `unit_price=${this.printParams.unit_price}`,
        `discount=${this.printParams.discount}`,
        `discountTotal=${this.printParams.discountTotal}`,
        `rowTotal=${this.printParams.rowTotal}`,
      ].join('&')
      const url = `${this.$store.state.app.baseURL}/export/offers/excel?token=${localStorage.getItem('refreshToken')}${urlParams}`
      return url
    },
    offerData() {
      return this.$store.getters['offers/getOffer']
    },
    offerLinesData() {
      return this.$store.getters['offers/getOfferLines']
    },
    getRevisedId() {
      return this.$store.getters['offers/getOfferRevisedId']
    },
  },
  watch: {
    offerData(val) {
      this.setFormData(val)
    },
    offerLinesData(val) {
      this.setLinesData(val)
    },
  },
  created() {
    this.getOffer()
    this.getOfferLines()
  },
  updated() {
    this.calcPublicTotal()
  },
  methods: {
    getOffer() {
      this.$store.dispatch('offers/offerView', this.$route.params.id)
    },
    getOfferLines() {
      this.$store.dispatch('offers/offerLinesList', {
        where: {
          'offer_lines.id_offers': this.$route.params.id,
        },
      })
    },
    priceFormater(price) {
      return new Intl.NumberFormat('tr-TR').format(price)
    },
    calcRowTotal(data) {
      let total = 0
      if (data.quantity) {
        const quantity = Number(data.quantity)
        const listPrice = Number(data.product_price)
        const laborPrice = Number(data.labor_price)
        total = (listPrice + laborPrice) * quantity
        if (data.discount_price) {
          total -= data.discount_price
        }
        if (data.discount_rate) {
          const discount = (total * data.discount_rate) / 100
          total -= discount
        }
        // eslint-disable-next-line no-param-reassign
        data.rowTotal = total
      }
      return new Intl.NumberFormat('tr-TR').format(total)
    },
    calcPublicTotal() {
      let result = 0
      if (this.linesData.length > 0) {
        const lines = this.linesData
        const total = []
        lines.forEach(e => {
          if (e.rowTotal) {
            total.push(e.rowTotal)
          }
        })
        result = total.reduce((a, b) => a + b, 0)
        result = new Intl.NumberFormat('tr-TR').format(result)
      }
      this.publicTotal = result
    },
    setFormData(data) {
      this.formData = data
    },
    setLinesData(data) {
      this.linesData = data
    },
    createRevised() {
      this.revisedLoading = true
      const { id } = this.formData
      this.$store.dispatch('offers/offerRevised', id)
        .then(response => {
          if (response) {
            this.$router.push(`/offers/edit/${response}`)
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
